import queryURLPreview from '../graphql/queries/queryURLPreview';
import updatePostMutation from '../graphql/mutations/updatePostMutation';
import { HeadersWithoutApiKeyWorkaround } from './constants';
import createPost from '../graphql/mutations/createPost';
import { performAudioUploadIfNeeded, performImageUploadIfNeeded } from './imageAudioUploadHelper';

export const state = () => ({});

export const actions = {
    async createPost(context, payload) {
        const [audio, image] = await Promise.all([performAudioUploadIfNeeded.bind(this)(payload.audioData), performImageUploadIfNeeded.bind(this)(payload.imageData)]);

        let imageInput = null;
        if (image) {
            imageInput = { name: image.fileName };
        }

        let audioInput = null;
        if (audio) {
            audioInput = { name: audio.fileName, provider: audio.provider };
        } else {
            console.log('No audio data: Payload', payload);
        }

        await this.app.apolloProvider.defaultClient.mutate({
            mutation: createPost.createPostMutation,
            context: this.$auth.loggedIn ? HeadersWithoutApiKeyWorkaround : null,
            variables: {
                campaignID: payload.campaignID,
                externalID: payload.externalID,
                audio: audioInput,
                image: imageInput,
            },
        });
    },

    async editPost(context, { campaignID, postID, imageData, link, externalID, bookmarked, contributorName }) {
        try {
            await this.$auth.refreshTokens();

            const [image, linkPreview] = await Promise.all([performImageUploadIfNeeded.bind(this)(imageData), fetchLinkPreviewIfNeeded.bind(this)(link)]);

            let imageInput = null;
            if (image) {
                imageInput = { name: image.fileName };
            }

            let linkInput = null;
            let removeLink = false;
            if (link && linkPreview) {
                linkInput = { title: linkPreview.title, url: linkPreview.url, imageURL: linkPreview.imageURL };
            } else {
                removeLink = true;
            }

            const response = await this.app.apolloProvider.defaultClient.mutate({
                mutation: updatePostMutation.updatePostMutation,
                context: HeadersWithoutApiKeyWorkaround,
                variables: {
                    postId: postID,
                    image: imageInput,
                    link: linkInput,
                    removeLink,
                    externalID,
                    bookmarked,
                    contributorName,
                },
            });

            if (response.data.updatePost) {
                const post = response.data.updatePost;
                await context.commit('campaign/setPost', post, { root: true });
            }
        } catch (e) {
            console.error(e);
            throw e;
        }
    },
};

export const mutations = {};

export const getters = {};

function fetchLinkPreviewIfNeeded(url) {
    if (!url) {
        return Promise.resolve(null);
    }

    return this.app.apolloProvider.defaultClient
        .query({
            query: queryURLPreview.urlPreview,
            fetchPolicy: 'no-cache',
            context: HeadersWithoutApiKeyWorkaround,
            variables: {
                url,
            },
        })
        .then(async (result) => {
            return result?.data?.urlPreview;
        })
        .catch((error) => {
            console.error('unable to resolve the link, skipping');
            console.error(error);
            return Promise.resolve(null);
        });
}
